import {
    Button,
    Grid,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@material-ui/core";
import React from "react";
import {Controller, useFieldArray} from "react-hook-form";
import {useTable} from "react-table";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import apiHelper from "../../../../util/ApiHelper";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    tableCell: {
        paddingTop: 3,
        paddingBottom: 3,
    },
    imgPreview: {
        maxHeight: "30px",
        width: "auto",
        cursor: "pointer"
    },
}));

const defaultValue = {
    id: "",
    localizations: {
        en: {image: "", url: ""},
        tc: {image: "", url: ""},
    },
};

export default function NestedLogoSection(props) {
    const {
        nestedIndex,
        control,
        data,
        setValue,
        activeLang,
        disabled,
    } = props;
    const classes = useStyles();
    const {
        fields,
        append,
    } = useFieldArray(
        {
            control,
            name: `footerColumns.${nestedIndex}.items`,
            keyName: "_id",
        }
    );

    const handleFileUpload = React.useCallback(
        async (event) => {
            console.log(event);
            console.log(event.target.name);
            const file = event.target.files[0];
            if (file) {
                const url = await uploadFile(file);
                setValue(event.target.name, url, {shouldDirty: true});
            }
        },
        [setValue]
    );

    const removeImage = (index) => {
        // console.log('oldFields', fields);
        const newFields = fields.reduce((acc, field, i) => {
            if (i !== index) {
                acc.push(field);
                return acc;
            }

            const updatedField = { ...field };
            const localizations = updatedField.localizations || {};

            if (localizations[activeLang]) {
                localizations[activeLang].image = '';
                localizations[activeLang].url = '';
            }

            const hasLocalizations = Object.keys(localizations).some(lang => {
                const localization = localizations[lang];
                return localization && (localization.image || localization.url);
            });

            if (hasLocalizations) {
                updatedField.localizations = localizations;
                acc.push(updatedField);
            }

            return acc;
        }, []);

        // console.log('newFields', newFields);
        setValue(`footerColumns.${nestedIndex}.items`, newFields);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "No.",
                accessor: "id",
                Cell: ({row}) => {
                    return <div>{row.index + 1}</div>;
                },
            },
            {
                Header: "Image",
                accessor: `localizations.${activeLang}.image`,
                Cell: ({row}) => {
                    return (
                        <Grid container alignItems="center"
                              xs={12}>
                            <Controller
                                defaultValue={data[row.index]?.localizations[activeLang]?.image}
                                name={`footerColumns.${nestedIndex}.items.${row.index}.localizations.${activeLang}.image`}
                                control={control}
                                render={({
                                             field,
                                             fieldState: {error}
                                         }) => (
                                    <>
                                        <Grid item xs={6}>
                                            <img
                                                className={classes.imgPreview}
                                                src={field.value}
                                                alt={field.value}
                                                onClick={() => window.open(field.value, '_blank').focus()}
                                            />
                                        </Grid>
                                        <input
                                            style={{display: "none"}}
                                            id={`upload-image-${nestedIndex}-${row.index}-${activeLang}`}
                                            type="file"
                                            name={`footerColumns.${nestedIndex}.items.${row.index}.localizations.${activeLang}.image`}
                                            onChange={handleFileUpload}
                                        />
                                        <Button
                                            component="label"
                                            htmlFor={`upload-image-${nestedIndex}-${row.index}-${activeLang}`}
                                            variant="outlined"
                                            margin="dense"
                                            disableElevation
                                        >
                                            {data[row.index] ? "Change Image" : "Add Image"}
                                        </Button>
                                    </>
                                )}
                            />
                        </Grid>
                    );
                },
            },
            {
                Header: "Url",
                accessor: `localizations.${activeLang}.url`,
                Cell: ({row, ...rest}) => {
                    return (
                        <Controller
                            defaultValue={
                                data[row.index]?.localizations[`${activeLang}`]?.url
                            }
                            name={`footerColumns.${nestedIndex}.items.${row.index}.localizations.${activeLang}.url`}
                            control={control}
                            render={({
                                         field,
                                         fieldState: {error}
                                     }) => (
                                <TextField
                                    variant="outlined"
                                    margin="dense"
                                    className={classes.textInput}
                                    fullWidth
                                    {...field}
                                    error={!!error}
                                    helperText={error ? error.message : ""}
                                />
                            )}
                        />
                    );
                },
            },
            {
                Header: "",
                id: "actions",
                Cell: ({ row }) => {
                    return (
                        <Button
                        onClick={() => {
                                removeImage(row.index);
                                // console.log('logo index removed', row.index);
                            }}
                            variant="text"
                            color="secondary"
                            disabled={disabled}
                            style={{ minWidth: 'auto' }}
                        >
                            <Close style={{ fontSize: "14px", lineHeight: "16px" }} />
                        </Button>
                    );
                },
            },
        ],
        [activeLang, data, nestedIndex, control, handleFileUpload, classes, disabled]
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({
        columns,
        data: fields,
    });

    const uploadFile = async (file) => {
        try {
            const result = await apiHelper.cinefan.uploadFile(file);
            console.log(result.data.url);
            return result.data.url;
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <Grid item xs={12}>
            <span>List of Logos</span>
            <TableContainer
                component={(props) => (
                    <Paper elevation={0}
                           variant="outlined" {...props} />
                )}
            >
                <Table {...getTableProps()} size="small">
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <TableCell
                                        {...column.getHeaderProps()}
                                        className={classes.tableCell}
                                    >
                                        {column.render("Header")}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {rows.map((row, i) => {
                            prepareRow(row);
                            return (
                                <TableRow {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return (
                                            <TableCell
                                                {...cell.getCellProps()}
                                                className={classes.tableCell}
                                            >
                                                {cell.render("Cell")}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid container xs={12}>
                {disabled || (
                    <Button
                        onClick={() => append(defaultValue)}
                        variant="text"
                        style={{
                            color: "#306F9D",
                            fontSize: "14px"
                        }}
                    >
                        <AddCircleIcon size="small"/>
                        Add New Logo
                    </Button>
                )}
            </Grid>
        </Grid>
    );
}
